import request from '../../utils/request'

const pre = "/system/version";

/**
 * 分页查询App版本列表
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export const reqPageVersion = (data) => {
    return request({
        url: pre + '/page',
        method: 'POST',
        data: data
    })
}

/**
 * 获取版本详情
 * @param {Number} id - 版本ID
 * @returns {Promise}
 */
export const reqGetVersionDetail = (id) => {
    return request({
        url: pre + '/detail?id=' + id,
        method: 'GET'
    })
}

/**
 * 新增版本
 * @param {Object} data - 版本信息
 * @returns {Promise}
 */
export const reqInsertVersion = (data) => {
    return request({
        url: pre + '/insert',
        method: 'POST',
        data: data
    })
}

/**
 * 更新版本
 * @param {Object} data - 版本信息
 * @returns {Promise}
 */
export const reqUpdateVersion = (data) => {
    return request({
        url: pre + '/update',
        method: 'POST',
        data: data
    })
}

/**
 * 删除版本
 * @param {Number} id - 版本ID
 * @returns {Promise}
 */
export const reqDeleteVersion = (id) => {
    return request({
        url: pre + '/delete?id=' + id,
        method: 'GET'
    })
}
